import { jsx as e } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { B as l } from "../Button-DIvSLTPg.js";
const m = i(({ active: r = !1, isRounded: t = !0, ...a }, o) => /* @__PURE__ */ e(l, { "data-cxy-name": "pill", pressed: r, ref: o, rounded: t, variant: "tertiary", ...a }));
m.displayName = "Pill";
export {
  m as Pill
};
